import MasterModal from './MasterModal';

const ClientModal = (props) => {
  return <MasterModal {...props} modalType="client" />;
};

export default ClientModal;
